import React, { useState, useEffect } from "react";
import { TbCalendarStar } from "react-icons/tb";
import { BsPersonPlusFill } from "react-icons/bs";
import "./add-atd.css";
import { Row, Form, Col, Button } from "react-bootstrap";
import { IoMdAdd } from "react-icons/io";
import axios from "axios";
// Custom Select Component
const CustomSelect = ({ options, value, onChange, placeholder }) => (
  <Form.Control
    as="select"
    value={value}
    onChange={(e) => onChange(parseInt(e.target.value))}
  >
    <option value="">{placeholder}</option>
    {options.map((option) => (
      <option key={option.userId} value={option.userId}>
        {option.username} {/* Display username instead of userId */}
      </option>
    ))}
  </Form.Control>
);
export default function AddAtd() {
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState(null);
  const [date, setDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [workedHours, setWorkedHours] = useState("");
  const [selectedUserDepartment, setSelectedUserDepartment] = useState(""); // Add department state
  // Fetch users
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(
          "https://backend.ems.hiradentallab.com/api/user/getAllUsers"
        );
        console.log("API Response:", response.data);
        const options = response.data.map((user) => ({
          userId: user.userId, // Ensure backend sends userId as an integer
          username: user.username,
        }));
        setUsers(options);
      } catch (error) {
        console.error("Error fetching users:", error);
        alert("Failed to fetch users. Please try again later.");
      }
    };
    fetchUsers();
  }, []);
 // Update department when user is selected
  // Update department when user is selected
  useEffect(() => {
    if (userId) {
      const selectedUser = users.find(user => user.userId === userId);
      setSelectedUserDepartment(selectedUser?.department || "");
    } else {
      setSelectedUserDepartment("");
    }
  }, [userId, users]);

  // Handle time changes
  const handleStartTimeChange = (event) => {
    setStartTime(event.target.value);
    calculateWorkedHours(event.target.value, endTime);
  };

  const handleEndTimeChange = (event) => {
    setEndTime(event.target.value);
    calculateWorkedHours(startTime, event.target.value);
  };

  // Corrected Worked Hours Calculation
  const calculateWorkedHours = (start, end) => {
    if (start && end) {
      let startDate = new Date(`1970-01-01T${start}:00`);
      let endDate = new Date(`1970-01-01T${end}:00`);

      // Handle overnight shifts (endTime is smaller than startTime)
      if (endDate < startDate) {
        endDate.setHours(endDate.getHours() + 24);
      }

      const diff = (endDate - startDate) / (1000 * 60 * 60);
      setWorkedHours(diff.toFixed(2));
    } else {
      setWorkedHours("");
    }
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!userId || !date || !startTime || !endTime) {
      alert("Please fill in all fields.");
      return;
    }
    try {
      const payload = {
        userId: Number(userId),
        date,
        checkIn: startTime,
        checkOut: endTime,
      };
      console.log("Submitting data:", payload);
      const response = await axios.post(
        "https://backend.ems.hiradentallab.com/api/attendance/manual-attendance",
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      if (response.data.success) {
        alert("Attendance added successfully.");
        setUserId("");
        setDate("");
        setStartTime("");
        setEndTime("");
        setWorkedHours("");
        setSelectedUserDepartment("");
      } else {
        alert(`Error: ${response.data.message}`);
      }
    } catch (error) {
      console.error("Error submitting attendance:", error);
      alert("An error occurred while adding attendance. Please try again.");
    }
  };

  return (
    <div className="container-fluid">
      <div>
        <h1 className="add-attendance-title">
          <TbCalendarStar /> Add Attendance
        </h1>
        <hr />
        <h1 className="add-attendance-subtitle">
          <BsPersonPlusFill /> Manual Attendance Record
        </h1>
        <hr />
      </div>
      <div className="add-attendance-container">
        <form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Form.Group as={Col} xs={12} md={3} controlId="formGridUsername">
              <Form.Label>
                User<span className="required">*</span> :
              </Form.Label>
              <CustomSelect
                options={users}
                value={userId || ""}
                onChange={setUserId}
                placeholder="--Select User--"
              />
            </Form.Group>
            <Form.Group as={Col} xs={12} md={3} controlId="formGridDate">
              <Form.Label>
                Date <span className="required">*</span> :
              </Form.Label>
              <Form.Control
                type="date"
                id="date"
                name="date"
                required
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Col} xs={12} md={3} controlId="formGridStartTime">
              <Form.Label>
                Start Time <span className="required">*</span>:
              </Form.Label>
              <Form.Control
                type="time"
                id="startTime"
                value={startTime}
                onChange={handleStartTimeChange}
              />
            </Form.Group>
            <Form.Group as={Col} xs={12} md={3} controlId="formGridEndTime">
              <Form.Label>
                End Time <span className="required">*</span>:
              </Form.Label>
              <Form.Control
                type="time"
                id="endTime"
                value={endTime}
                onChange={handleEndTimeChange}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} xs={12} md={3} controlId="formGridWorkedHours">
              <Form.Label>
                Worked Hours<span className="required">*</span> :
              </Form.Label>
              <Form.Control type="text" readOnly value={workedHours} />
            </Form.Group>
          </Row>
          <Button type="submit" className="btn btn-primary">
            <IoMdAdd /> Add Attendance
          </Button>
        </form>
      </div>
    </div>
  );
}